import { makeAutoObservable } from 'mobx';
import { injectable } from 'inversify';
import { IOsiPaymentFormViewModel } from '@shared/types/mobx/entities/osiPayments';
import logger from 'js-logger';
import { notifications } from '@shared/utils/notifications';
import { Abonent } from '@shared/types/osi/abonents';
import { AreaTypeCodes } from '@shared/types/dictionaries';
// Хелпер добавляет префикс типа помещения (Неж-/Парк-/Клад-) к номеру, как на вкладке сальдо
import { makeFlat } from '@shared/utils/helpers/makeFlat';

const ADDITIONAL_SERVICE_GROUP_ID_LEGACY = 7;

@injectable()
export class OsiPaymentFormViewModel implements IOsiPaymentFormViewModel {
  isLoading = false;

  constructor() {
    makeAutoObservable(this);
  }

  private _abonents: Abonent[] = [];

  set abonents(value: Abonent[]) {
    this._abonents = value;
  }

  private _submitCb: any = async () => {};

  set submitCb(value: any) {
    this._submitCb = value;
  }

  getAbonents(serviceGroupId: number): Abonent[] {
    // Миграция: external удалён из БД; арендатор определяется по areaTypeCode
    if (serviceGroupId === ADDITIONAL_SERVICE_GROUP_ID_LEGACY) {
      return this._abonents?.filter((abonent) => abonent.areaTypeCode === AreaTypeCodes.ARENDATOR);
    }

    return this._abonents?.filter((abonent) => abonent.areaTypeCode !== AreaTypeCodes.ARENDATOR);
  }

  getAbonentOptionLabel = (option: Abonent) => {
    // Фаза 2: арендатор → flatDisplay (единый отображаемый номер от backend), иначе прежний лейбл
    if (option.areaTypeCode === AreaTypeCodes.ARENDATOR) {
      return option.flatDisplay ?? (option.name || option.flat);
    }

    // Префикс типа помещения (Неж-/Парк-/Клад-), жилые — просто номер (как на вкладке сальдо)
    const flatLabel = makeFlat(option) || 'Нет помещения';
    if (!option.name) {
      return flatLabel;
    }

    return `${flatLabel} - ${option.name}`;
  };

  onSubmit = async (values: any): Promise<void> => {
    try {
      this.isLoading = true;

      await this._submitCb?.(values);
    } catch (e) {
      logger.error(e);
      notifications.error();
    } finally {
      this.isLoading = false;
    }
  };
}
